import isValidMobileNumber from '../../../features/auth/utils/isValidMobileNumber'
import isEqual from '../../../utils/lodashUtils/isEqual'
import { emailValidation } from '../../../utils/validations'
import isExpiredDate from './isExpiredDate'

export const isHotelConfigChanged = (currentRooms = [], rooms = []) => {
	const currentRoomCount = currentRooms.length
	let returnedValue = false
	if (currentRoomCount !== rooms.length) {
		returnedValue = true
	} else {
		for (let index = 0; index < currentRoomCount; index++) {
			if (
				currentRooms[index].adultCount !== rooms[index].adultCount ||
				(currentRooms[index].childAges || []).length !==
					(rooms[index].childAges || []).length ||
				!isEqual(currentRooms[index].childAges, rooms[index].childAges)
			) {
				returnedValue = true
				break
			} else {
				continue
			}
		}
	}
	return returnedValue
}
const compareValue = (str1 = '', str2 = '') => {
	return str1 !== str2
}
/**
 * Used to find whether Get-Cost button is enable or not
 * @param {*} itineraryInfo
 * @param {*} costing-object
 * @author Akbar Basha KM
 */
export default function isEnableGetCost({
	itineraryInfo = {},
	gcmData: {
		departureCity,
		date,
		nights,
		roomConfigurations,
		flightsBookedByUserAlready = false,
		arrivalCity,
		nationalityCode,
		userIntent,
		passenger_details,
	},
	// user_details,
	packages,
	// locale = '',
	isLoggedIn,
}) {
	// const { user_details = {}, packages, locale } = store.getState().app;
	const { costingConfiguration, itinerary = { nights: null, costed: false } } =
		itineraryInfo
	// const isCred = isCredBali(itineraryInfo) || isCredDeals();

	const isMaldives =
		itineraryInfo?.itinerary?.regionCode === 'mle' ||
		packages?.campaignDetails?.regionCode === 'mle'

	if (costingConfiguration && itinerary.costed && isLoggedIn) {
		const {
			departureAirport,
			arrivalAirport,
			departureDate,
			hotelGuestRoomConfigurations,
			nationality,
		} = costingConfiguration
		return (
			compareValue(departureAirport, departureCity) ||
			compareValue(arrivalAirport, arrivalCity) ||
			(compareValue(departureDate, date) && !isExpiredDate(date)) ||
			compareValue(nights, itinerary.nights) ||
			isHotelConfigChanged(roomConfigurations, hotelGuestRoomConfigurations) ||
			compareValue(nationalityCode.value, nationality)
			/**
			 * Once get flightBookedByUserAlerady value from backend we need to enable it
			 * @akbar
			 */
			// || compareValue(flightsBookedByUserAlready, costingConfiguration.flightsBookedByUserAlready)
		)
	}

	if (isLoggedIn) {
		return (
			(departureCity || flightsBookedByUserAlready || nationalityCode) &&
			date != '' &&
			date !== null &&
			(isMaldives ? userIntent : true) &&
			!isExpiredDate(date)
		)
	}

	const { name, mobileNumber, email, countryPhoneCode } =
		passenger_details || {}

	return (
		// (departureCity || flightsBookedByUserAlready || isCred || nationalityCode) &&
		(departureCity || flightsBookedByUserAlready || nationalityCode) &&
		!!name &&
		emailValidation(email) &&
		mobileNumber &&
		isValidMobileNumber(`${countryPhoneCode}${mobileNumber}`) &&
		date != '' &&
		date !== null &&
		(isMaldives ? userIntent : true) &&
		!isExpiredDate(date)
	)
}
